import React from 'react';
import PropTypes from 'prop-types';

import { PaymentBanner } from 'dpl/common/components/PriceBreakdownModal';
import {
  ANALYTICS_VIEWS,
  ANALYTICS_VIEW_FEATURE_LOCATIONS
} from 'dpl/constants/analytics';

import {
  getDepositRefundPolicyAdjective,
  getDepositSecuresText,
  getFinalPaymentTimingText
} from './util';

function getDepositTermsSentence({
  depositRefundPolicy,
  depositSecures,
  finalPaymentTiming
}) {
  const refundPolicyAdjective =
    getDepositRefundPolicyAdjective(depositRefundPolicy);
  // The deposit terms modal never names a dog, even for a specific_puppy
  // deposit, so getDepositSecuresText is called without a dog name.
  const securesText = getDepositSecuresText(depositSecures);
  const timingText = getFinalPaymentTimingText(finalPaymentTiming);

  const sentences = [];

  if (securesText) {
    sentences.push(
      `This ${
        refundPolicyAdjective ? `${refundPolicyAdjective} ` : ''
      }deposit reserves ${securesText}.`
    );
  } else if (refundPolicyAdjective) {
    // No secures clause to attach the adjective to, so state it as its own
    // claim rather than the dangling "This refundable deposit."
    sentences.push(`This deposit is ${refundPolicyAdjective}.`);
  }

  if (timingText) {
    sentences.push(`The remaining balance is due ${timingText}.`);
  }

  return sentences.join(' ');
}

/** @param {any} props */
export default function DepositTermsContent({
  depositRefundPolicy = null,
  depositSecures = null,
  finalPaymentTiming = null,
  tooltipDescription = null
}) {
  const sentence = getDepositTermsSentence({
    depositRefundPolicy,
    depositSecures,
    finalPaymentTiming
  });

  return (
    <>
      {sentence && <p>{sentence}</p>}
      {tooltipDescription && (
        <p
          className={sentence ? 'mt4' : null}
        >{`Breeder’s policy: “${tooltipDescription}”`}</p>
      )}
      <PaymentBanner
        className="mt6"
        view={ANALYTICS_VIEWS.PAYMENT_DETAILS}
        viewFeatureLocation={
          ANALYTICS_VIEW_FEATURE_LOCATIONS.PAYMENT_CHECKOUT_PAGE
        }
      />
    </>
  );
}

export const depositTermsPropTypes = {
  depositRefundPolicy: PropTypes.string,
  depositSecures: PropTypes.string,
  finalPaymentTiming: PropTypes.string,
  tooltipDescription: PropTypes.string
};

DepositTermsContent.propTypes = depositTermsPropTypes;
